import { render } from "./read-more-less.vue?vue&type=template&id=50982179"
import script from "./read-more-less.vue?vue&type=script&lang=js"
export * from "./read-more-less.vue?vue&type=script&lang=js"

import "./read-more-less.vue?vue&type=style&index=0&id=50982179&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__